module.exports = __webpack_public_path__ + "static/media/icon_entertainment.1fdca22e.svg";